import { FC, memo } from "react";
import ChatMessage from "./ChatMessage";

export const MemoizedChatMessage = memo(
    ChatMessage,
    (prevProps, nextProps) => (
        prevProps.message.content === nextProps.message.content
    )
);
